export const isTablet = window.screen.width > 500 && window.screen.width <= 1200
export const isMobile = window.screen.width <= 500
export const deviceHeight = window.screen.height
